export const customBadgeVariants = {
  overdue: "border-transparent hover:bg-international-orange/80 bg-international-orange text-black text-[10px] font-semibold px-1.5",
  overdueSoon: "border-transparent hover:bg-international-yellow/80 bg-international-yellow text-black text-[10px] font-semibold px-1.5",
}
